export function selectwidgets(state) {
  return state.widgetsData.widgets;
}
